const GET_ALL_JOBS_FOR_GROUP = `GET_ALL_JOBS_FOR_GROUP`;
const GET_ALL_JOBS_FOR_GROUP_SUCCESS = `${GET_ALL_JOBS_FOR_GROUP}/SUCCESS`;
const GET_ALL_JOBS_FOR_GROUP_FAILURE = `${GET_ALL_JOBS_FOR_GROUP}/FAILURE`;

const GET_ALL_JOBS = `GET_ALL_JOBS`;
const GET_ALL_JOBS_SUCCESS = `${GET_ALL_JOBS}/SUCCESS`;
const GET_ALL_JOBS_FAILURE = `${GET_ALL_JOBS}/FAILURE`;

const GET = `GET`;
const GET_SUCCESS = `${GET}/SUCCESS`;
const GET_FAILURE = `${GET}/FAILURE`;

const TRIGGER = `TRIGGER`;
const TRIGGER_SUCCESS = `${TRIGGER}/SUCCESS`;
const TRIGGER_FAILURE = `${TRIGGER}/FAILURE`;

const STOP = `STOP`;
const STOP_SUCCESS = `${STOP}/SUCCESS`;
const STOP_FAILURE = `${STOP}/FAILURE`;

const RESUME = `RESUME`;
const RESUME_SUCCESS = `${RESUME}/SUCCESS`;
const RESUME_FAILURE = `${RESUME}/FAILURE`;

export default {
  GET_ALL_JOBS_FOR_GROUP,
  GET_ALL_JOBS_FOR_GROUP_SUCCESS,
  GET_ALL_JOBS_FOR_GROUP_FAILURE,

  GET_ALL_JOBS,
  GET_ALL_JOBS_SUCCESS,
  GET_ALL_JOBS_FAILURE,

  GET,
  GET_SUCCESS,
  GET_FAILURE,

  TRIGGER,
  TRIGGER_SUCCESS,
  TRIGGER_FAILURE,

  STOP,
  STOP_SUCCESS,
  STOP_FAILURE,

  RESUME,
  RESUME_SUCCESS,
  RESUME_FAILURE
};
